import { Directive, ElementRef, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';

@Directive({
  selector: '[trimmedEmail]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TrimmedEmailValidatorDirective),
      multi: true,
    },
  ],
})
export class TrimmedEmailValidatorDirective implements Validator {
  
  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Allow empty values
    }
    const oldValue: string = control.value; 
    const trimmedValue: string = control.value.trim();
    if(oldValue !== trimmedValue)
      control.setValue(trimmedValue, { emitEvent: false, onlySelf: true });
    return CustomValidators.email(control);
  }
}